export default "__VITE_ASSET__BgTB0UDP__"